
/**Angular imports */

import {
  Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
/**Third party libraries */
import { select, Store } from '@ngrx/store';
// tslint:disable-next-line:rxjs-proper-imports
import { Subscription } from 'rxjs';
import {
  debounceTime, takeWhile
} from 'rxjs/operators';
import { ApiCallClass } from '../../../../shared/modal/apicall.modal';
import { ServerApi } from '../../../../shared/outer-services/app.apicall.service';
/**Custom imports */
import { EventDispatchService } from '../../../../shared/outer-services/event-dispatch.service';
import { StorageService } from '../../../../shared/outer-services/storage.service';
import { Utilities } from '../../../../shared/outer-services/utilities.service';
import {
  GetDashboardPersonalInfoAction
} from '../../../../state-management/actions/dashboard.action';
import { dashboardPersonalInfoSelector } from '../../../../state-management/reducers/dashboard.reducer';
import { dashboardPersonalInfoState } from '../../../../state-management/state/dashboard.state';
import { FrameworkConfigState } from '../../../../state-management/state/main-state';
import { plpSectionFunction, PLPSharedService } from '../../../PLP/shared/shared/PLP-shared.service';
import * as PlanActions from './state-management/action/plan.action';
import { SetPlanSummaryDataAction } from './state-management/action/plan.action';
import { Plan } from './state-management/model/plan.model';
import * as PlanReducer from './state-management/selector/plan.selector';
import { planSummarySelector } from './state-management/selector/plan.selector';
import { PlanUserSummaryState } from './state-management/state/plan-state';


@Component({
  selector: 'app-plans-dynamic',
  templateUrl: './personalized_plans.html',
})
export class PlansDynamicComponent implements OnInit, OnDestroy {
  @Input('FrameworkObj') FrameworkObj;
  @Output() changeInrView = new EventEmitter();
  IsPlanViewMode = true; /**Declare for storing the url. */
  menuState = false; /**Declare for storing the boolean value. */
  opts; /**Declare for storing the css values. */
  sectionObject;
  filledStatusVariable = [];
  subscription =
    new Subscription(); /** Declare to listen if any change occured.*/
  subscription1 =
    new Subscription(); /** Declare to listen if any change occured.*/
  urlArr: string[];
  plansData: any;
  activePlan: any;
  nextComp: any;
  subscription4: Subscription;
  PlansSummary: any;
  subscription3: Subscription;
  subscribe2: Subscription;
  frameSub: Subscription;
  singleLoad = true;

  // active plan chart variables
  activePlanChartType: string = 'doughnut';
  activePlanChartLabels: string[] = ['Completed', 'Started', 'Incomplete'];
  activePlanChartData: number[];
  activePlanChartColors: string[] = ['#008000', '#dd7c09', '#646262'];
  activeChartWidth: string = '140px';
  activeChartHeight: string = '140px';
  chartWidth: string = '85px';
  chartHeight: string = '85px';
  cutout: string = '70%';
  centerText: boolean = true;
  //end of chart variables


  itemId: number;
  routeChangedItem: any;
  planchangeInx: any;
  PlanIndex = 0;
  compActive = true;
  personalData;
  @ViewChild('plan_header', { static: true }) main: ElementRef;
  // events
  public chartClicked(e: any): void {
    // console.log(e);
  }

  public chartHovered(e: any): void {
    // console.log(e);
  }

  changeView(evnt) {
    this.changeInrView.emit(evnt);
  }

  hasPlanSummary: boolean = true;

  constructor(
    private store: Store<Plan>,
    private util: Utilities,
    private FrameworkStore: Store<FrameworkConfigState>,
    private router: Router,
    private plpShared: PLPSharedService,
    private eventService: EventDispatchService,
    private activeRoute: ActivatedRoute,
    private loginauth: ServerApi,
    private storageService: StorageService,
    public personalInfoStore: Store<dashboardPersonalInfoState>,
    public plansummaryStore: Store<PlanUserSummaryState>,
    private titleService: Title
  ) {
    this.personalInfoStore.dispatch(new GetDashboardPersonalInfoAction());
    this.personalInfoStore
      .pipe(
        select(dashboardPersonalInfoSelector),
        takeWhile(() => this.compActive)
      )
      .subscribe((personalInfoResponse) => {
        this.personalData = personalInfoResponse;
      });
    this.eventService
      .menucloselisten()
      .pipe(takeWhile(() => this.compActive))
      .subscribe((e) => {
        if (e.type == 'menuBar') {
          this.menuToggle('menuBar');
        }
      });
    /* Here we have to load the specific plan based on either LTI or redirect route navigation , which is in the pattern(plan|planIndex|itemIndex)*/
    let planLtidata;
    if (this.storageService.sessionStorageGet('locationModule')) {
      planLtidata = JSON.parse(
        this.storageService.sessionStorageGet('locationModule')
      ).componentId.split('|');
      /* this if condition allows when the pattern having only plan id */
      if (planLtidata[1]) {
        this.store.dispatch(
          new PlanActions.ChangePlanIndex(parseInt(planLtidata[1]) - 1)
        );
      }
    }
    this.store
      .pipe(
        select(PlanReducer.getItem),
        takeWhile(() => this.compActive)
      )
      .subscribe((planItem) => {
        this.itemId = planItem;
        /* This if condition case allows us to navigating from form to form in formIO*/
        if (this.storageService.sessionStorageGet('locationModule')) {
          planLtidata = JSON.parse(
            this.storageService.sessionStorageGet('locationModule')
          ).componentId.split('|');
          // }
          // /* This if condition case allows us to navigating from form to form in formIO*/
          // if (planLtidata && planLtidata[0] === 'formid') {
          if (this.FrameworkObj) {
            this.idSet(
              this.FrameworkObj['compList'].find(
                (obj) => this.itemId == obj.ItemID
              )
            );
          }
        }
        /* For LTI pattern navigation */
        if (!planItem && planLtidata && planLtidata[2]) {
          this.store.dispatch(
            new PlanActions.AddItem(parseInt(planLtidata[2]) - 1)
          );
          this.store.dispatch(new PlanActions.ChangePlanView(true));
        } else if (!planItem) {
          this.store.dispatch(new PlanActions.AddItem(0));
          this.store.dispatch(new PlanActions.ChangePlanView(true));
        }
      });
    this.store
      .pipe(
        select(PlanReducer.getPlanIndex),
        takeWhile(() => this.compActive)
      )
      .subscribe((resoponsePlanIndex) => {
        if (!resoponsePlanIndex && resoponsePlanIndex != 0) {
          this.store.dispatch(new PlanActions.ChangePlanIndex(0));
        } else {
          this.PlanIndex = resoponsePlanIndex;
        }
      });
    this.store
      .pipe(
        select(PlanReducer.getIsPlanViewMode),
        takeWhile(() => this.compActive)
      )
      .subscribe((IsPlanViewMode) => {
        this.IsPlanViewMode = IsPlanViewMode;
      });
    this.storageService.sessionStorageSet('inTab', '');
    this.subscription = this.eventService.listen().subscribe((e) => {
      try {
        if (
          e.type == 'PlanCompStatus' ||
          e.type.indexOf('&Filled') !== -1 ||
          e.type.indexOf('&Empty') !== -1
        ) {
          const itemid = this.itemId;
          const planId = parseInt(this.storageService.sessionStorageGet('planId'), 10) || 0;
          const planinx = this.PlanIndex;
          /* if PlanID and ItemID are defined then the respective Status apicall is done */
          if (itemid && planId) {
            const apiJson2 = new ApiCallClass();
            apiJson2.method = 'GET';
            apiJson2.endUrl =
              '/Dynamicicap/UserActivity/' +
              this.util.getAccountId() +
              '/' +
              planId +
              '/' +
              itemid +
              '?stateAbbr=stateAbbr&lang=en';
            apiJson2.moduleName = 'dynamicicap/';
            apiJson2.method = 'GET';
            this.subscription3 = this.loginauth
              .callDynamicPlpApi([apiJson2])
              .subscribe((respSetting2) => {
                this.summerycall();
                this.activeplanMethod();
                const evnt = document.createEvent('CustomEvent');
                evnt.initEvent(
                  'statusChange&' +
                  planinx +
                  '&' +
                  itemid +
                  '&' +
                  respSetting2[0].Result,
                  true,
                  true
                );
                this.eventService.dispatch(evnt);
                this.FrameworkObj = this.util.getFrameObjbyId();
              });
          }
        }
        if (e.type === 'unsaved' && this.routeChangedItem) {
          this.navigateToNext(this.routeChangedItem);
          this.routeChangedItem = [];
        }
      } catch (e) {
        console.log('Plans constructor inside exception:' + e.message);
      }
    });
    this.subscription = this.eventService
      .listenStaticContent()
      .subscribe((e) => {
        if (this.main) {
          this.main.nativeElement.setAttribute('tabindex', '0');
          this.main.nativeElement.focus();
        }
      });
    /** Framework store reflection **/
    this.frameSub = this.FrameworkStore.select('config').subscribe((v) => {
      const frameObjByid = this.util.getFrameObjbyId();
      if (
        v &&
        v.config &&
        v.config.Result &&
        v.config.Result.lang &&
        v.config.Result.lang === this.storageService.sessionStorageGet('langset')
      ) {
        this.util.hideLoading();

      }
      if (
        frameObjByid &&
        JSON.parse(
          this.storageService.sessionStorageGet('loginPlansConfiguration')
        )
      ) {
        const plansData1 = JSON.parse(
          this.storageService.sessionStorageGet('loginPlansConfiguration')
        ).plan;
        if (frameObjByid['compList'] && frameObjByid['compList'].length !== 0) {
          this.FrameworkObj = frameObjByid;
        }
        this.nextComp = [];
        let nextCompId = 0;
        /** The nextCompId is for finding the next module that is to be completed,
         *  so when we click on countinue or next button we will be navigated to that module in the 'Dynamic PLP Dashboard' view.
         *  To find the first 'not started' module or the next 'in progress' module or
         *  first 'completed' module.
         */
        if (plansData1 && plansData1[this.PlanIndex]) {
          for (
            let j = 0;
            j < plansData1[this.PlanIndex]['ItemsList'].length;
            j++
          ) {
            if (
              plansData1[this.PlanIndex]['ItemsList'][
                j
              ].CompletionStatus.toLowerCase() === 'in progress' &&
              !nextCompId
            ) {
              nextCompId = plansData1[this.PlanIndex]['ItemsList'][j].ItemID;
            } else if (
              plansData1[this.PlanIndex]['ItemsList'][
                j
              ].CompletionStatus.toLowerCase() === 'not started' &&
              !nextCompId
            ) {
              nextCompId = plansData1[this.PlanIndex]['ItemsList'][j].ItemID;
            }
          }
        }
        if (this.FrameworkObj) {
          for (let k = 0; k < this.FrameworkObj['compList'].length; k++) {
            if (
              this.FrameworkObj['compList'][k].ItemID === nextCompId &&
              nextCompId &&
              this.nextComp.length === 0
            ) {
              this.nextComp = this.FrameworkObj['compList'][k];
            }
          }

          for (let m = 0; m < this.FrameworkObj['compList'].length; m++) {
            if (!this.itemId) {
              if (
                this.FrameworkObj.defaultComp ===
                this.FrameworkObj['compList'][m].compId
              ) {
                plpSectionFunction(this.FrameworkObj);
                this.sectionObject = this.plpShared.getPlanSectionObject(
                  this.FrameworkObj['compList'][m].ItemID
                );
                break;
              } else if (m === this.FrameworkObj['compList'].length - 1) {
                plpSectionFunction(this.FrameworkObj);
                this.sectionObject = this.plpShared.getPlanSectionObject(
                  this.FrameworkObj['compList'][0].ItemID
                );
              }
            } else if (m === this.FrameworkObj['compList'].length - 1) {
              plpSectionFunction(this.FrameworkObj);
              this.sectionObject = this.plpShared.getPlanSectionObject(
                this.itemId
              );
            }
          }
        }

        if (this.storageService.sessionStorageGet('locationModule')) {
          const planLtiVal = JSON.parse(
            this.storageService.sessionStorageGet('locationModule')
          ).componentId.split('|');
          if (planLtiVal[1] && planLtiVal[2]) {
            const planSession = JSON.parse(
              this.storageService.sessionStorageGet('loginPlansConfiguration')
            ).plan;
            if (
              planSession[parseInt(planLtiVal[1]) - 1] &&
              planSession[parseInt(planLtiVal[1]) - 1].ItemsList[
              parseInt(planLtiVal[2]) - 1
              ]
            ) {
              const newPlanObj = this.FrameworkObj['compList'].find(
                (obj) =>
                  planSession[parseInt(planLtiVal[1]) - 1].ItemsList[
                    parseInt(planLtiVal[2]) - 1
                  ].ItemID == obj.ItemID
              );
              if (newPlanObj) {
                this.idSet(newPlanObj);
                this.storageService.sessionStorageRemove('locationModule');
                planLtidata = undefined;
              }
            }
          }
        }
      }
    });
  }
  activeplanMethod() {
    try {
      //this.summerycall();
      this.plansummaryStore
        .pipe(
          select(planSummarySelector),
          takeWhile(() => this.compActive)
        )
        .subscribe((responseData) => {

          if (responseData) {


            this.hasPlanSummary = true;
            this.plansData = responseData.planSummary['Result'];
            this.PlansSummary = responseData.planSummary['Result'];
            if (this.IsPlanViewMode && this.singleLoad) {
              this.planModify(this.PlanIndex);
              this.singleLoad = false;
            } else {
              this.plansData = JSON.parse(
                this.storageService.sessionStorageGet('loginPlansConfiguration')
              ).plan;
              for (let k = 0; k < this.PlansSummary.length; k++) {
                for (let i = 0; i < this.plansData.length; i++) {
                  if (
                    this.PlansSummary[k].PlanID === this.plansData[i].PlanID
                  ) {
                    this.plansData[i].completed =
                      this.PlansSummary[k].NumberActivityCompleted;
                    this.plansData[i].started =
                      this.PlansSummary[k].NumberActivityInProgress;
                    this.plansData[i].NotStarted =
                      this.PlansSummary[k].NumberActivityNotStarted;
                    this.plansData[i].total =
                      this.PlansSummary[k].NumberActivityCompleted +
                      this.PlansSummary[k].NumberActivityInProgress +
                      this.PlansSummary[k].NumberActivityNotStarted;
                  }
                }
              }
              if (this.plansData) {
                const planId =
                  parseInt(this.storageService.sessionStorageGet('planId'), 10) ||
                  this.plansData[0].PlanID;



                this.activePlan = this.plansData.find((val) => {
                  return val.PlanID == planId;
                });

                this.activePlanChartData = [(this.activePlan?.completed), (this.activePlan?.started), (this.activePlan?.NotStarted)];

              }
              this.util.hideLoading();
            }
          }
          else {
            this.hasPlanSummary = false;
          }
        });
    } catch (e) {
      console.log('plans error-->', e.message);
    }
  }
  /** user summary Api call for count */
  async ngOnInit() {
    if (
      !this.storageService.sessionStorageGet('IsPlanIsPlanViewMode') ||
      this.storageService.sessionStorageGet('IsPlanIsPlanViewMode') == 'true'
    ) {
      this.IsPlanViewMode = true;
      this.storageService.sessionStorageSet('IsPlanIsPlanViewMode', 'true');
    } else {
      this.IsPlanViewMode = false;
      this.storageService.sessionStorageSet('IsPlanIsPlanViewMode', 'false');
    }
    this.nextComp = [];
    this.activeplanMethod();
    //This variable is used to check that the user has clicked plp activity very first time or not .
    /*Without this logic when the user clicks very first time on the dynamic PLP left side menu activity,
          it could not be able to load the corresponding intro page.
          Here it checks the variable and calls the idset ().
          So, Now the user navigates to the intro page for the very first time.*/
    let forFirstTime = true;

    if (this.FrameworkObj && !this.FrameworkObj.defaultComp) {
      this.FrameworkObj.defaultComp = this.FrameworkObj['compList'][0].compId;
    }
    this.router.events
      .pipe(
        debounceTime(200),
        takeWhile(() => this.compActive)
      )
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          if (
            !this.router.url.includes('assessment') &&
            this.routeChangedItem &&
            this.routeChangedItem.ItemID &&
            this.routeChangedItem.ItemID !== this.itemId
          ) {
            this.navigateToNext(this.routeChangedItem);
          } else if (
            (this.planchangeInx || this.planchangeInx === 0) &&
            this.router.url.includes('assessment') === false
          ) {
            this.planChangeAfterAcceptance(this.planchangeInx);
          }
          /*here spliting the plan url and checking array of 1st index.
                    if it is not empty then calling planChangeAcceptance().
                 So, this page will navigate to home page of the plp.
               */
          if (!this.router.url.split('plan')[1]) {
            this.planChangeAfterAcceptance(this.PlanIndex);
          } else if (this.FrameworkObj['compList'] && forFirstTime) {
            forFirstTime = false;
            // this.idSet(this.FrameworkObj['compList'].find(obj => this.router.url.includes(obj.url.replace('.', ''))));
            /*All forms/assessments/print having their own url's. So, changed the logic based on itemid instead of urls. */
            const foundItem = this.FrameworkObj['compList'].find(
              (obj) => this.itemId == obj.ItemID
            );
            if (foundItem) {
              this.idSet(foundItem);
            }
          }
        }
      });
    await this.summerycall();

    this.setDocTitle('Personal Learning Plan');
  }
  async summerycall() {
    await this.loginauth.getUserSummery().then((respUserData) => {
      this.plansData = respUserData['Result'];
      this.plansummaryStore.dispatch(
        new SetPlanSummaryDataAction(respUserData)
      );
    });
  }
  navigateToRelativeUrl(inx) {
    if (this.IsPlanViewMode === false) {
      this.router.navigate(['.'], { relativeTo: this.activeRoute.parent });
    }
    if (this.router.url.includes('assessment') === false) {
      this.planChangeAfterAcceptance(inx);
    } else {
      this.routeChangedItem = [];
      this.planchangeInx = inx;
    }
  }
  planChangeAfterAcceptance(inx) {
    this.store.dispatch(new PlanActions.ChangePlanView(true));
    this.planchangeInx = undefined;
    this.planModify(inx);
  }
  planModify(index) {
    const evnt = document.createEvent('CustomEvent');
    evnt.initCustomEvent('FooterDispatch', true, true, '');
    this.eventService.dispatch(evnt);
    this.store.dispatch(new PlanActions.ChangePlanView(true));
    this.util.showLoading();
    this.nextComp = [];
    this.storageService.sessionStorageRemove('itemId');
    this.itemId = -1;
    this.plansData = JSON.parse(
      this.storageService.sessionStorageGet('loginPlansConfiguration')
    ).plan;
    for (let i = 0; i < this.plansData.length; i++) {
      if (index === i) {
        this.activePlan = this.plansData[index];
        this.store.dispatch(new PlanActions.ChangePlanIndex(i));
        this.storageService.sessionStorageSet('planId', this.activePlan.PlanID);
        evnt.initEvent('PlanChange', true, true);
        this.eventService.dispatch(evnt);
      }
      for (let k = 0; k < this.PlansSummary.length; k++) {
        if (this.PlansSummary[k].PlanID === this.plansData[i].PlanID) {
          this.plansData[i].completed =
            this.PlansSummary[k].NumberActivityCompleted;
          this.plansData[i].started =
            this.PlansSummary[k].NumberActivityInProgress;
          this.plansData[i].NotStarted =
            this.PlansSummary[k].NumberActivityNotStarted;
          this.plansData[i].total =
            this.PlansSummary[k].NumberActivityCompleted +
            this.PlansSummary[k].NumberActivityInProgress +
            this.PlansSummary[k].NumberActivityNotStarted;
        }
      }
    }

    if (this.plansData) {
      const planId =
        parseInt(this.storageService.sessionStorageGet('planId'), 10) ||
        this.plansData[index].PlanID;
      this.activePlan = this.plansData.find((val) => {
        return val.PlanID == planId;
      });
      //update activePlan chartdata
      this.activePlanChartData = [(this.activePlan?.completed), (this.activePlan?.started), (this.activePlan?.NotStarted)];

    }
  }
  idSet(item) {
    this.planchangeInx = undefined;
    const evnt = document.createEvent('CustomEvent');
    evnt.initCustomEvent('FooterDispatch', true, true, '');
    this.eventService.dispatch(evnt);
    this.routeChangedItem = item;
    if (item.url.indexOf('custom-form') !== -1) {
      item.url = './dynamicform/custom-form';
    }
    if (item.url.indexOf('custom-widget') != -1) {
      item.url = './dynamicwidget/' + item.ItemID + '/custom-widget';
    }
    if (item.url.indexOf('custom-print') != -1) {
      item.url = './dynamicprint/' + item.ItemID + '/custom-print';
    }
    // For form io ids
    if (item.CustomAttr) {
      this.storageService.sessionStorageSet(
        'CustomAttr',
        JSON.stringify(item.CustomAttr)
      );
    } else if (this.storageService.sessionStorageGet('CustomAttr')) {
      this.storageService.sessionStorageRemove('CustomAttr');
    }
    const navigateAndThen = () => {
      // Ensure navigateToNext is executed after navigation completes so
      // any route-based checks in that method see the updated URL.
      if (this.router.url.includes('assessment') === false) {
        this.navigateToNext(item);
      }
    };

    if (this.router.url.indexOf('custom-form') !== -1) {
      // Load the parent then the child and invoke follow-up after navigation
      this.router
        .navigate(['.'], { relativeTo: this.activeRoute.parent })
        .then(() => {
          // if navigating to print, store the full item so CustomPrintComponent can read it
          if (item.url.indexOf('custom-print') !== -1) {
            this.storageService.sessionStorageSet('printItem', JSON.stringify(item));
          }
          return this.router.navigate([item.url], { relativeTo: this.activeRoute });
        })
        .then(() => navigateAndThen())
        .catch(() => navigateAndThen());
    } else {
      // Navigate and then run the follow-up
      // if navigating to print, store the full item so CustomPrintComponent can read it
      if (item.url.indexOf('custom-print') !== -1) {
        this.storageService.sessionStorageSet('printItem', JSON.stringify(item));
      }
      this.router
        .navigate([item.url], { relativeTo: this.activeRoute })
        .then(() => navigateAndThen())
        .catch(() => navigateAndThen());
    }
    this.storageService.sessionStorageRemove('locationModule');
    this.menuClose();
  }

  saveChanges() {
    return true;
  }
  navigateToNext(item) {
    this.storageService.sessionStorageSet('careerShow', '0');
    this.storageService.sessionStorageSet('progschool', 'false');
    this.storageService.sessionStorageSet('inTab', '');
    if (this.activePlan) {
      this.storageService.sessionStorageSet('planId', this.activePlan.PlanID);
    }
    this.store.dispatch(new PlanActions.ChangePlanView(false));
    this.store.dispatch(new PlanActions.AddItem(item.ItemID));
    this.storageService.sessionStorageSet('activeSortId', item.compId);
    this.storageService.sessionStorageSet('showHeaderText', '0');
    this.storageService.sessionStorageRemove('prevRoute');
    this.storageService.sessionStorageRemove('filterSettings');
    document.title = item.compName;
    const evnt = document.createEvent('CustomEvent');
    evnt.initEvent('plpTile&' + item.name, true, true);
    this.eventService.dispatch(evnt);
    if (item.compId === 'sortCCIJr') {
      this.storageService.sessionStorageSet('CCIassessment', 'CCIJr');
    } else {
      this.storageService.sessionStorageSet('CCIassessment', 'CCIAdult');
    }
    this.routeChangedItem = [];
    this.menuState = false;
  }

  menuToggle(parentMenuopen?) {
    if (!parentMenuopen) {
      const evnt = document.createEvent('CustomEvent');
      evnt.initEvent('hideBar', true, true);
      this.eventService.menucloseDispatch(evnt);
      this.menuState = !this.menuState;
    } else {
      this.menuState = false;
    }
  }

  /**This method gets executed while closing the menu. */
  menuClose() {
    this.menuState = false;
  }

  /**
   * This method is for changing the view of the header.
   * @param evnt declare for event occuring.
   */
  changeViewHeader(evnt) {
    try {
      const name = evnt;
      this.sectionObject = this.plpShared.getPlanSectionObject(this.itemId);
      // this.sectionObject = this.plpShared.getPlanSectionObject(parseInt(this.storageService.sessionStorageGet('itemId'), 10));
    } catch (e) {
      console.log('Exception in PlpComponent oninit' + e.message);
    }
  }

  /**
   * This method is used for unsubscribing the event.
   */
  ngOnDestroy() {
    this.compActive = false;
    this.store.dispatch(new PlanActions.ChangePlanView(true));
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.subscription1) {
      this.subscription1.unsubscribe();
    }
    if (this.subscription4) {
      this.subscription4.unsubscribe();
    }
    if (this.subscription3) {
      this.subscription3.unsubscribe();
    }
    if (this.subscribe2) {
      this.subscribe2.unsubscribe();
    }
    if (this.frameSub) {
      this.frameSub.unsubscribe();
    }
  }
  /**title service */
  public setDocTitle(title: string) {
    this.titleService.setTitle(title + ' - CIS360');
  }
}
